'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgValidateInstructions(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M11.993 2c.591 0 1.082.456 1.137 1.033l.006.11v9.714c0 .592-.456 1.082-1.033 1.138l-.11.005h-8a1.147 1.147 0 01-1.138-1.033l-.005-.11V3.143c0-.592.456-1.082 1.033-1.138L3.993 2h8zM9.707 3.929a.643.643 0 01-.643.642H6.921a.643.643 0 010-1.285l-2.357-.001a.429.429 0 00-.428.428v8.572c0 .237.192.428.428.428h6.857a.429.429 0 00.429-.428V3.713a.429.429 0 00-.429-.428H9.064c.355 0 .643.289.643.644zm.64 2.892l.058.046.04.044a.55.55 0 01-.068.753l-2.8 2.574a.766.766 0 01-1.03-.005l-.944-.91a.562.562 0 01-.06-.763l.04-.043.059-.046a.634.634 0 01.788.079l.622.618L9.54 6.885a.665.665 0 01.807-.064z", fill: "currentColor" }))));
}

module.exports = SvgValidateInstructions;
//# sourceMappingURL=ValidateInstructions.js.map
